import { useState } from "react";
import "../styles/testimonials.css";
import { ADMIN_PASSWORD } from "../data/constants";

export default function Testimonials({ testimonials, setTestimonials }) {
  const empty = { type: "", firstName: "", lastName: "", company: "", rating: 0, services: [], text: "" };
  const [form, setForm] = useState(empty);
  const [submitted, setSubmitted] = useState(false);
  const [hovered, setHovered] = useState(0);
  const [errors, setErrors] = useState({});
  const [adminMode, setAdminMode] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [pw, setPw] = useState("");
  const [pwError, setPwError] = useState("");

  const handleAdminLogin = () => {
    if (pw === ADMIN_PASSWORD) { setAdminMode(true); setShowLogin(false); setPwError(""); setPw(""); }
    else setPwError("Incorrect password.");
  };

  const deleteReview = (id) => setTestimonials((prev) => prev.filter((t) => t.id !== id));

  const setF = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const toggleSvc = (s) => setF("services", form.services.includes(s) ? form.services.filter((x) => x !== s) : [...form.services, s]);

  const validate = () => {
    const e = {};
    if (!form.type) e.type = "Please select a customer type.";
    if (!form.firstName.trim()) e.firstName = "First name is required.";
    if (!form.lastName.trim()) e.lastName = "Last name is required.";
    if (!form.company.trim()) e.company = "Company name is required.";
    if (!form.rating) e.rating = "Please select a star rating.";
    if (form.services.length === 0) e.services = "Please select at least one service.";
    if (form.text.trim().length < 20) e.text = "Please write at least 20 characters.";
    return e;
  };

  const handleSubmit = () => {
    const e = validate();
    if (Object.keys(e).length > 0) { setErrors(e); return; }
    const initials = (form.firstName[0] + form.lastName[0]).toUpperCase();
    setTestimonials((prev) => [{
      id: Date.now(),
      type: form.type,
      name: form.firstName + " " + form.lastName[0] + ".",
      company: form.company,
      rating: form.rating,
      text: form.text,
      service: form.services.join(" & "),
      avatar: initials,
    }, ...prev]);
    setForm(empty);
    setErrors({});
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
  };

  const ratingLabels = ["", "Poor", "Fair", "Good", "Great", "Excellent"];

  return (
    <div className="testimonials">

      {/* Admin Login Modal */}
      {showLogin && (
        <div className="testimonials__modal-overlay">
          <div className="testimonials__modal">
            <h2 className="testimonials__modal-title">Admin Login</h2>
            <input
              type="password"
              placeholder="Password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleAdminLogin()}
              className="testimonials__modal-input"
            />
            {pwError && <div className="testimonials__modal-error">{pwError}</div>}
            <div className="testimonials__modal-actions">
              <button className="testimonials__modal-login" onClick={handleAdminLogin}>Login</button>
              <button className="testimonials__modal-cancel" onClick={() => { setShowLogin(false); setPw(""); setPwError(""); }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Page Header */}
      <div className="testimonials__header">
        <p className="testimonials__eyebrow">WHAT OUR CUSTOMERS SAY</p>
        <h1 className="testimonials__title">Testimonials</h1>
        <p className="testimonials__subtitle">Hear from the fleet managers and owner-operators who trust Race City Truck Solutions to keep their rigs on the road.</p>
      </div>

      {/* Review Cards */}
      <div className="testimonials__grid">
        {testimonials.map((t) => (
          <div key={t.id} className="testimonial__card">
            {adminMode && (
              <button className="testimonial__delete" onClick={() => deleteReview(t.id)} title="Delete review">×</button>
            )}
            <div className="testimonial__top">
              <div className="testimonial__avatar">{t.avatar}</div>
              <div>
                <div className="testimonial__name">{t.name}</div>
                <div className="testimonial__company">{t.company}</div>
                <div className="testimonial__type">{t.type}</div>
              </div>
            </div>
            <div className="testimonial__stars">
              {[1,2,3,4,5].map((i) => (
                <span key={i} className={"star " + (i <= t.rating ? "star--filled" : "star--empty")}>★</span>
              ))}
            </div>
            <p className="testimonial__text">"{t.text}"</p>
            <div className="testimonial__service">{t.service}</div>
          </div>
        ))}
      </div>

      {/* Review Form */}
      <div className="testimonials__form-wrap">
        <div className="testimonials__form-header">
          <p className="testimonials__form-eyebrow">SHARE YOUR EXPERIENCE</p>
          <h2 className="testimonials__form-title">Leave a Review</h2>
        </div>

        {submitted && (
          <div className="testimonials__success">Thank you! Your review has been posted.</div>
        )}

        <div className="testimonials__form-grid">
          <div className="testimonials__form-field testimonials__form-field--full">
            <label className="testimonials__form-label">Customer Type *</label>
            <select value={form.type} onChange={(e) => setF("type", e.target.value)} className="testimonials__form-input">
              <option value="">-- Select Type --</option>
              <option value="Owner-Operator">Owner-Operator</option>
              <option value="Fleet Manager">Fleet Manager</option>
            </select>
            {errors.type && <div className="testimonials__form-error">{errors.type}</div>}
          </div>

          <div className="testimonials__form-field">
            <label className="testimonials__form-label">First Name *</label>
            <input className="testimonials__form-input" placeholder="John" value={form.firstName} onChange={(e) => setF("firstName", e.target.value)} />
            {errors.firstName && <div className="testimonials__form-error">{errors.firstName}</div>}
          </div>

          <div className="testimonials__form-field">
            <label className="testimonials__form-label">Last Name *</label>
            <input className="testimonials__form-input" placeholder="Smith" value={form.lastName} onChange={(e) => setF("lastName", e.target.value)} />
            {errors.lastName && <div className="testimonials__form-error">{errors.lastName}</div>}
          </div>

          <div className="testimonials__form-field testimonials__form-field--full">
            <label className="testimonials__form-label">Company Name *</label>
            <input className="testimonials__form-input" placeholder="Smith Logistics LLC" value={form.company} onChange={(e) => setF("company", e.target.value)} />
            {errors.company && <div className="testimonials__form-error">{errors.company}</div>}
          </div>

          <div className="testimonials__form-field testimonials__form-field--full">
            <label className="testimonials__form-label">Rating *</label>
            <div className="testimonials__stars-input">
              {[1,2,3,4,5].map((i) => (
                <span key={i}
                  className={"star-pick " + (i <= (hovered || form.rating) ? "star-pick--active" : "")}
                  onMouseEnter={() => setHovered(i)}
                  onMouseLeave={() => setHovered(0)}
                  onClick={() => setF("rating", i)}>★</span>
              ))}
            </div>
            {form.rating > 0 && (
              <div className="testimonials__rating-label">
                {ratingLabels[form.rating]} — {form.rating} star{form.rating > 1 ? "s" : ""}
              </div>
            )}
            {errors.rating && <div className="testimonials__form-error">{errors.rating}</div>}
          </div>

          <div className="testimonials__form-field testimonials__form-field--full">
            <label className="testimonials__form-label">Services Received *</label>
            <div className="testimonials__svc-options">
              {["Repair", "Service", "Wash/Detailing"].map((s) => (
                <label key={s} className={"testimonials__svc-option " + (form.services.includes(s) ? "testimonials__svc-option--selected" : "")}>
                  <input type="checkbox" checked={form.services.includes(s)} onChange={() => toggleSvc(s)} />
                  {s}
                </label>
              ))}
            </div>
            {errors.services && <div className="testimonials__form-error">{errors.services}</div>}
          </div>

          <div className="testimonials__form-field testimonials__form-field--full">
            <label className="testimonials__form-label">Your Review *</label>
            <textarea
              className="testimonials__form-textarea"
              placeholder="Tell us about your experience with Race City Truck Solutions..."
              value={form.text}
              onChange={(e) => setF("text", e.target.value)}
            />
            <div className="testimonials__char-count">{form.text.length} characters (min 20)</div>
            {errors.text && <div className="testimonials__form-error">{errors.text}</div>}
          </div>
        </div>

        <button className="testimonials__submit" onClick={handleSubmit}>Submit Review</button>
      </div>

      {/* Admin Button — below form, before footer */}
      <div className="testimonials__admin-wrap">
        {!adminMode
          ? <button className="testimonials__admin-login-btn" onClick={() => setShowLogin(true)}>🔒 Admin Login</button>
          : <button className="testimonials__admin-exit-btn" onClick={() => setAdminMode(false)}>Exit Admin Mode</button>
        }
      </div>

    </div>
  );
}